import axios from 'axios'

export default {
  all: () => axios.get(`/api/nations`).then(response => response.data)
}
